import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface StudentClassroomState {
  classroomId: number | null
  isStudent: boolean | null
  createdAt: string | null
  updatedAt: string | null
  name: string | null
  subject: string | null
  emoji: string | null
  teacherLastName: string | null
  startDate: string | null
  defaultSchedule: boolean | null
  inviteCode: string | null
  courseVersion: number | null
  latestCourseVersion: number | null
  mheCourseVersion: number | null
  latestMHECourseVersion: number | null
  archived: boolean | null
}

export const selectStudentClassrooms = (state: any) => state.studentClassrooms
export const selectClassroomId = (state: any) => state.studentClassrooms[0]?.classroomId
export const selectCourseVersion = (state: any) => state.studentClassrooms[0]?.courseVersion
export const selectActiveStudentClassrooms = (state: any) => state.studentClassrooms.filter((classroom: StudentClassroomState) => !classroom.archived)
export const selectStudentClassroomById = (classroomId: number) => (state: any) => !classroomId ? null : state.studentClassrooms.find((classroom: StudentClassroomState) => classroom.classroomId === classroomId)

// example classroom: {
//   classroomId: null, // number
//   isStudent: null, // bool
//   createdAt: null, // str (timestamp)
//   updatedAt: null, // str (timestamp)
//   name: null, // str
//   subject: null, // str
//   email: null, // str
//   teacherLastName: null, // str
//   startDate: null, // str (timestamp)
//   defaultSchedule: null, // bool
//   inviteCode: null, // str
//   courseVersion: null, // number
//   latestCourseVersion: null, // number
//   mheCourseVersion: null, // number
//   latestMHECourseVersion: null, // number
//   archived: null, // bool
// },

const initialState: StudentClassroomState[] = []

const studentClassroomsSlice = createSlice({
  name: 'studentClassrooms',
  initialState,
  reducers: {
    loadStudentClassrooms: (state, { payload: classrooms }: PayloadAction<any[]>) =>
      classrooms.map((classroom: any) => ({
        classroomId: classroom.classroomId,
        isStudent: classroom.isStudent,
        createdAt: classroom.createdAt,
        updatedAt: classroom.updatedAt,
        name: classroom.name,
        subject: classroom.subject,
        emoji: classroom.emoji,
        teacherLastName: classroom.teacherLastName,
        startDate: classroom.startDate,
        defaultSchedule: classroom.defaultSchedule,
        inviteCode: classroom.inviteCode,
        courseVersion: classroom.courseVersion,
        latestCourseVersion: classroom.latestCourseVersion,
        mheCourseVersion: classroom.mheCourseVersion,
        latestMHECourseVersion: classroom.latestMHECourseVersion,
        archived: classroom.archived,
      }))
  },
})

export const { loadStudentClassrooms } = studentClassroomsSlice.actions

export default studentClassroomsSlice.reducer
